import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonCard = styled.div`
  background: linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%);
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 24px;
  min-height: 200px;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.4) 50%,
      transparent 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.5s infinite;
  }
`;

const SkeletonElement = styled.div`
  background: linear-gradient(
    90deg,
    #e8e8e8 0%,
    #f5f5f5 50%,
    #e8e8e8 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: ${props => props.$radius || '4px'};
`;

const IconSkeleton = styled(SkeletonElement)`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  flex-shrink: 0;
`;

const ValueSkeleton = styled(SkeletonElement)`
  width: 60px;
  height: 40px;
  margin-left: 16px;
`;

const LabelSkeleton = styled(SkeletonElement)`
  width: 140px;
  height: 18px;
  margin-top: 16px;
`;

const SparklineSkeleton = styled(SkeletonElement)`
  width: 100%;
  height: 40px;
  margin-top: 16px;
  border-radius: 8px;
`;

const TrendSkeleton = styled(SkeletonElement)`
  width: 120px;
  height: 22px;
  margin-top: 10px;
  border-radius: 10px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

/**
 * Skeleton loading state for stat cards
 */
const StatCardSkeleton = () => {
  return (
    <SkeletonCard>
      <Row>
        <IconSkeleton />
        <ValueSkeleton />
      </Row>
      <LabelSkeleton />
      <SparklineSkeleton />
      <TrendSkeleton />
    </SkeletonCard>
  );
};

export default StatCardSkeleton;
